import { useEffect } from "react";
import { useLocale } from "ttag";

import { useSettingsStore } from "@/shared/stores";

export const useInitLanguage = () => {
  const language = useSettingsStore((state) => state.language);
  useLocale(language);

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  return language;
};
